export default function resolveFaviconHref(
    isWhitelabel: boolean,
    companyLogoUrl: string | null,
    defaultFaviconHref: string,
): string {
    if (isWhitelabel && companyLogoUrl) {
        return companyLogoUrl;
    }

    return defaultFaviconHref;
}
